import type { FaireProductEntity } from "../../entity_types/product";

export const p_3p2sdd4dpb: FaireProductEntity = {
  token: "p_3p2sdd4dpb",
  type: "product",
  name: "Floral Smocked Tiered Midi Dress FD0050",
  brandToken: "b_e3yxzqwr92",
  brandName: "Forte",
  imageUrl:
    "https://cdn.faire.com/fastly/23596c5c5dd8b5ddc22b2f774a83250301dbde84f03c4e34cdcb1f946fdb61fc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/119d82f173113ce1b5702574c7490e60f1fc075306df6dc33044b73666ae5e1e.jpeg",
    "https://cdn.faire.com/fastly/f0035f5ce27461b27b6b00109270cec4276e6bb3b7fe2d276d79925dd4f4bef6.jpeg",
    "https://cdn.faire.com/fastly/fddf7a38d0dac347f7a7396131918738dfcd13acf166dd03a98b5ad7a56df578.jpeg",
    "https://cdn.faire.com/fastly/9649b944b5c43dd4791e132f160b17edefeaa2c508bb5d5b4891ebb63390f39d.jpeg",
    "https://cdn.faire.com/fastly/a06928859b16c7938fe36b43f71f543de01fbb6bce3d89403bd42ce60d4b7fc7.jpeg",
    "https://cdn.faire.com/fastly/0a5ab425fa390eebfebfd78dd6cdbb6b80630d327994ebfb31b9adf343448f94.jpeg",
    "https://cdn.faire.com/fastly/31c1272292afcc9651d2da93905a8e7db428fd6da9c050953045e797c7e9db4f.jpeg",
    "https://cdn.faire.com/fastly/13e680429043d581b8ea95fc868225558febd0b5e375f4b9d904e133593cc9e9.jpeg",
    "https://cdn.faire.com/fastly/6e96d324f522dfcb7ece44a15872dc0deb9cbe78e3308c4d045c2c35d61da02f.jpeg",
    "https://cdn.faire.com/fastly/e1384a162460741e5c3053315d0d46e8d9cd7accb6f941ada1d99b65e9b276d0.jpeg",
    "https://cdn.faire.com/fastly/cccdb44f9f09eec6b1354f9b1337e8f534ff9b1f0e5b0f86827443a1a3f11414.jpeg",
    "https://cdn.faire.com/fastly/5d0f382aeece28f0fd33087612c12f6ecf22c1dee3e65f72c3c26dd4218a8692.jpeg",
    "https://cdn.faire.com/fastly/e4ad97cc3ba0f5cbb259d5510441de47191ac33fbd26f77cfc229e74a74ebd32.jpeg",
    "https://cdn.faire.com/fastly/27ff47530edb3a4fab7f575340b9d8993389b36c135da47f5b2c6ae75c99659e.jpeg",
    "https://cdn.faire.com/fastly/049727cac54345a45ad42be43c3798f00477e7e8c566493fdf0b0df02164954b.jpeg",
    "https://cdn.faire.com/fastly/b7777a1ab22101226cbbbc9183b44a9a6ece8ee0c6feb67b47d675c5721b89dd.jpeg",
    "https://cdn.faire.com/fastly/b36677cbeff8c444872ab77d9447fea97b46f8165b0214ea645410da03f72107.jpeg",
    "https://cdn.faire.com/fastly/6e2e4b30b21007a22194fa943cfe31e997cfa6f5ff487663c28741067775b9d2.jpeg",
    "https://cdn.faire.com/fastly/1c51c26157d4337809b3cd6f062116696bd1edc4fe83a77f9101c52b419ace66.jpeg",
    "https://cdn.faire.com/fastly/3e462fc45101add43b0044bc6b16e760940e1dae26e41de60614ddedb71b7e1e.jpeg",
  ],
  priceDollars: 220.5,
  description:
    "- Lightweight Cotton Fabric: Made from breathable, soft cotton that feels airy and comfortable for all-day wear\n- Fully Lined: Designed with a full lining for added coverage and a smooth, comfortable fit\n- Smocked Bodice: Stretch smocking through the bust creates a flexible, flattering silhouette that contours comfortably\n- Wide Ruffle Straps: Soft ruffled shoulder straps add feminine detail while providing secure support\n- Tiered Midi Skirt: Multi-tiered construction adds volume and movement, creating an effortless Midi Dress shape\n- Functional Side Pockets: Hidden side pockets offer everyday practicality without interrupting the flowy design\n- Model is 5' 8.5\" 31-24-34 and wearing a size Small\n\nRomantic and breathable, this lightweight cotton Midi Dress blends vintage-inspired Boho charm with easy Dresses styling-perfect for warm days, weekend outings, or vacation wear, delivering soft structure, graceful movement, and timeless femininity in one effortless piece.",
  tags: [],
  msrpDollars: 441,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:46.742Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
